// export function loadGoogleMaps() {
//   const apiKey = process.env.REACT_APP_GOOGLE_WEB_API_KEY;
//   const script = document.createElement("script");
//   script.async = true;
//   script.defer = true;
//   script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&loading=async&libraries=places&callback=initAutocomplete`;

//   document.body.appendChild(script);
// }

let googleMapsPromise = null;

export function loadGoogleMaps() {
  if (googleMapsPromise) return googleMapsPromise;

  googleMapsPromise = new Promise((resolve, reject) => {
    // Already loaded
    if (window.google?.maps) {
      resolve();
      return;
    }

    const apiKey = process.env.REACT_APP_GOOGLE_WEB_API_KEY;

    const script = document.createElement("script");
    script.async = true;
    script.defer = true;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&loading=async&libraries=places&callback=initAutocomplete`;

    script.onload = () => resolve();
    script.onerror = (err) => reject(err);

    document.body.appendChild(script);
  });

  return googleMapsPromise;
}
